import React, {useState} from "react";
import {Button, Empty, Image, Modal, Table, Tooltip} from "antd";
import moment from "moment";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import "../../../../index.css";
import {CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom/cjs/react-router-dom.min";
import {creditLogsObjectionTypes} from "../../../../constants/constants";
import {EmptyMessage} from "../../../_defaultComponents/EmptyMessage/EmptyMessage";

export const PacketObjectionTable = ({
    objectionData,
    pageState,
    handleChangeStatusForObjection,
    readOnlyStatus = false
}) => {
    const [page, setPage] = pageState;
    const [visibleChangeStatusModal, setVisibleChangeStatusModal] = handleChangeStatusForObjection;
    const [visible, setVisible] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);

    const handlePreviewFiles = files => {
        setSelectedFiles(files);
        setVisible(true);
    };

    return (
        <div className="objectionTableContainer">
            <Table
                dataSource={objectionData?.data?.rows}
                pagination={{
                    total: objectionData?.data?.dataCount,
                    current: page,
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                    onChange: page => {
                        setPage(page);
                    }
                }}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                size="small"
                scroll={{x: "max-content"}}
                rowKey={"_id"}
                expandable={{
                    expandedRowRender: record => (
                        <div className="objectionDetailTableContainer" style={{padding: "5px"}}>
                            <Table
                                dataSource={record.creditLogs}
                                pagination={false}
                                className="objectionDetailWrapper"
                                style={{margin: 0}}
                                prefixCls="creditObjectionDetailTable ant-table"
                            >
                                <Table.Column
                                    title="İşlem Türü"
                                    dataIndex="transactionType"
                                    render={transactionType =>
                                        transactionType === "USE" ? "Harcama" : "Teslimat"
                                    }
                                />
                                <Table.Column title="Ücret Tipi" dataIndex="subType" />
                                <Table.Column
                                    title="Kurye Ücreti"
                                    dataIndex="courierAmount"
                                    render={courierAmount =>
                                        courierAmount ? `${courierAmount} TL` : "-"
                                    }
                                />
                                <Table.Column
                                    title="Müşteri Ücreti"
                                    dataIndex="clientAmount"
                                    render={clientAmount =>
                                        clientAmount ? `${clientAmount} TL` : "-"
                                    }
                                />
                            </Table>
                        </div>
                    )
                }}
                rowExpandable={record => record?.creditLogs?.length > 0}
            >
                <Table.Column
                    title="Alt Firma Adı"
                    dataIndex="subCompany"
                    key="subCompany"
                    render={subCompany => (
                        <span data-testid="subCompany">
                            <Tooltip placement="topLeft" title={subCompany}>
                                {subCompany || "-"}
                            </Tooltip>
                        </span>
                    )}
                />
                <Table.Column
                    title="Kullanıcı Adı"
                    dataIndex="createdBy"
                    key="createdBy"
                    ellipsis={{showTitle: false}}
                    render={createdBy => (
                        <span data-testid="createdBy">
                            <Tooltip placement="topLeft" title={createdBy}>
                                {createdBy || "-"}
                            </Tooltip>
                        </span>
                    )}
                />
                <Table.Column
                    title="Sipariş Numarası"
                    dataIndex="deliveryId"
                    key="deliveryId"
                    width={110}
                    render={(deliveryId, record) => {
                        return record?.order?.vigoOrderNumber ? (
                            <Link
                                target="_blank"
                                data-testid="orderNumber"
                                style={{maxWidth: "470px"}}
                                to={{
                                    pathname: "/orders/" + deliveryId
                                }}
                            >
                                {record?.order?.vigoOrderNumber}
                            </Link>
                        ) : (
                            <Link
                                target="_blank"
                                data-testid="orderNumber"
                                style={{maxWidth: "470px"}}
                                to={{pathname: "/orders/" + deliveryId}}
                            >
                                {record?.order?.orderNumber}
                            </Link>
                        );
                    }}
                />
                <Table.Column
                    title="Sipariş Oluşturma Tarihi"
                    dataIndex="deliveryCreatedAt"
                    key="deliveryCreatedAt"
                    render={deliveryCreatedAt => (
                        <span>{moment(deliveryCreatedAt).format("DD/MM/YYYY")}</span>
                    )}
                />
                <Table.Column
                    title="İtiraz Oluşturma Tarihi"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={createdAt => <span>{moment(createdAt).format("DD/MM/YYYY")}</span>}
                />
                <Table.Column
                    title="İtiraz Tipi"
                    dataIndex="type"
                    key="type"
                    width={120}
                    ellipsis={{showTitle: false}}
                    render={type => (
                        <span data-testid="type">
                            <Tooltip
                                placement="topLeft"
                                title={
                                    creditLogsObjectionTypes.find(obj => obj.value === type)
                                        ?.label || "-"
                                }
                            >
                                {creditLogsObjectionTypes.find(obj => obj.value === type)?.label ||
                                    "-"}
                            </Tooltip>
                        </span>
                    )}
                />
                <Table.Column
                    title="İtiraz Nedeni"
                    dataIndex="reason"
                    key="reason"
                    render={reason => {
                        return (
                            <span>
                                {(reason === "incorrectDistance" && "Mesafe İtirazı") ||
                                    (reason === "incorrectDelivery" && "Teslimat İtirazı") ||
                                    (reason === "other" && "Diğer") ||
                                    (reason === "incorrectPayment" && "Ödeme itirazı")}
                            </span>
                        );
                    }}
                />
                <Table.Column
                    title="İtiraz Tutarı"
                    dataIndex="requestedAmount"
                    key="requestedAmount"
                    render={requestedAmount => <span>{requestedAmount + "TL"}</span>}
                />
                <Table.Column
                    title="Sipariş Durumu"
                    dataIndex="order"
                    key="order"
                    ellipsis={{showTitle: false}}
                    render={(order, record) => {
                        return (
                            <span data-testid="order">
                                <Tooltip
                                    placement="topLeft"
                                    title={
                                        order
                                            ? order?.state === "delivered"
                                                ? "Teslim Edildi"
                                                : order?.state === "canceled"
                                                ? "İptal Edildi (Otomatik Ödendi)"
                                                : order?.state === "waitingForDelivery" &&
                                                  record?.creditLogs?.find(
                                                      log => log.subType === "REFUND"
                                                  )
                                                ? "İptal Edildi (Otomatik Ödendi)"
                                                : order?.state === "waitingForDelivery"
                                                ? "Teslimat İçin Bekliyor"
                                                : order?.state === "onDelivery"
                                                ? "Teslimatta"
                                                : order?.state == "returned"
                                                ? "İade Edildi"
                                                : order?.state === "pending"
                                                ? "Beklemede"
                                                : order?.state
                                            : "-"
                                    }
                                >
                                    <span>
                                        {order
                                            ? order?.state === "delivered"
                                                ? "Teslim Edildi"
                                                : order?.state === "canceled"
                                                ? "İptal Edildi (Otomatik Ödendi)"
                                                : order?.state === "waitingForDelivery" &&
                                                  record?.creditLogs?.find(
                                                      log => log.subType === "REFUND"
                                                  )
                                                ? "İptal Edildi (Otomatik Ödendi)"
                                                : order?.state === "waitingForDelivery"
                                                ? "Teslimat İçin Bekliyor"
                                                : order?.state === "onDelivery"
                                                ? "Teslimatta"
                                                : order?.state == "returned"
                                                ? "İade Edildi"
                                                : order?.state === "pending"
                                                ? "Beklemede"
                                                : order?.state
                                            : "-"}
                                    </span>
                                </Tooltip>
                            </span>
                        );
                    }}
                />
                <Table.Column
                    title="Açıklama"
                    dataIndex="note"
                    key="note"
                    width={160}
                    ellipsis={{showTitle: false}}
                    render={note => (
                        <span data-testid="note">
                            <Tooltip placement="topLeft" title={note}>
                                {note || "-"}
                            </Tooltip>
                        </span>
                    )}
                />
                <Table.Column
                    title="Belge"
                    style={{textAlign: "left"}}
                    dataIndex="files"
                    key="_id"
                    rowKey="_id"
                    width={140}
                    align="center"
                    render={files =>
                        files && files.length > 0 ? (
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <Button
                                    size="small"
                                    style={{height: "auto", fontSize: "12px", lineHeight: 1.2}}
                                    type="ghost"
                                    onClick={() => handlePreviewFiles(files)}
                                >
                                    <>
                                        Belgeleri
                                        <br />
                                        Görüntüle
                                    </>
                                </Button>
                            </div>
                        ) : (
                            "Belge yok"
                        )
                    }
                />
                <Table.Column
                    title="Durum"
                    dataIndex="status"
                    key="status"
                    width={170}
                    align="center"
                    render={(status, record) => (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <CustomButton
                                size="small"
                                onClick={
                                    readOnlyStatus
                                        ? undefined
                                        : () => {
                                              setVisibleChangeStatusModal({
                                                  visible: true,
                                                  objectionId: record._id,
                                                  objection: {...record}
                                              });
                                          }
                                }
                                style={{
                                    borderRadius: "10px",
                                    fontSize: "12px",
                                    marginRight: 0,
                                    cursor: readOnlyStatus ? "default" : undefined
                                }}
                                type={
                                    (status === "rejected" && "danger") ||
                                    (status === "approved" && "ghost") ||
                                    (status === "pending" && "primary")
                                }
                                icon={
                                    (status === "approved" && <CheckCircleOutlined />) ||
                                    (status === "rejected" && <CloseCircleOutlined />) ||
                                    (status === "pending" && <ClockCircleOutlined />)
                                }
                                disabled={
                                    !readOnlyStatus &&
                                    (status === "approved" || status === "rejected") && true
                                }
                            >
                                {(status === "rejected" && "Reddedildi") ||
                                    (status === "approved" && "Onaylandı") ||
                                    (status === "pending" && "Beklemede")}
                            </CustomButton>
                        </div>
                    )}
                />
            </Table>
            <Modal
                visible={visible}
                footer={null}
                onCancel={() => setVisible(false)}
                width={800}
                title="Belgeleri Önizle"
            >
                <div style={{display: "flex", flexWrap: "wrap", justifyContent: "center"}}>
                    {selectedFiles.map(file =>
                        file && file?.mimetype?.includes("pdf") ? (
                            <a
                                href={file.publicUrl}
                                target="_blank"
                                rel="noreferrer"
                                key={file._id}
                                style={{margin: 10}}
                            >
                                <Button type="primary">PDF Görüntüle</Button>
                            </a>
                        ) : (
                            file.publicUrl && (
                                <Image
                                    key={file._id}
                                    src={file.publicUrl}
                                    width={200}
                                    height={200}
                                    style={{objectFit: "contain", margin: 10}}
                                />
                            )
                        )
                    )}
                </div>
            </Modal>
        </div>
    );
};
